// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"c7-z"};